import { useState } from 'react'

const STORAGE_KEY = 'login_session'

export default function useLogin() {
  const getLogin = () => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : null
    } catch {
      return null
    }
  }

  const [login, setLoginState] = useState(getLogin)

  const setLogin = (loginData) => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(loginData))
    setLoginState(loginData)
  }

  const clearLogin = () => {
    sessionStorage.removeItem(STORAGE_KEY)
    setLoginState(null)
  }

  return {
    login,
    setLogin,
    clearLogin,
  }
}
